'use client'

import { Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material'
import { NavLink } from 'react-router'
import { settingsIcons } from '../../constants'

export default function SettingCard(params: any) {
	const Icon = settingsIcons[params.icon]

	return (
		<Card elevation={0}>
			<CardActionArea component={NavLink} to={params.link}>
				<CardContent>
					<Stack flexDirection={'row'} gap={2}>
						<Icon />
						<Stack>
							<Typography variant="h6">{params.title}</Typography>
							<Typography variant="body2">{params.description}</Typography>
						</Stack>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	)
}
